import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import NavigationButton from "./navigation_button";


type SuccessComponentProps = {
  title?: string;
  message?: any;
  buttonText?: string;
  onButtonClick?: () => void;
  isPlain?: boolean;
};

const SuccessComponent: React.FC<SuccessComponentProps> = (

  {

    title = "Thank you for sharing your story with us!",
    message = <div></div>,
    buttonText = "Open Mail",
    onButtonClick = () => { },
    isPlain = false

  }) => {
  const [animationData, setAnimationData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {

    fetch("/lottie/Success-tick.json")
      .then((response) => response.json())
      .then((data) => setAnimationData(data));
  }, []);

  useEffect(() => {
    if (animationData) {
      setIsLoading(false);
    }
  }, [animationData]);

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="w-full items-center justify-center flex">
      <div className={isPlain ? "" : "md:w-[500px] md:h-[327px] bg-white px-[24px] py-[30px] items-center justify-center flex-col flex rounded-lg shadow-[0px_20px_24px_-4px_rgba(16,24,40,0.08),0px_8px_8px_-4px_rgba(16,24,40,0.03)]"}>

        {isLoading ? (
          <></>
        ) : (
          <Lottie options={defaultOptions} height={120} width={120} />
        )}

        <div className="text-center text-[#1d2939] text-base font-semibold font-['Inter'] leading-normal py-[8px]">
          {title}
        </div>
        <div className="text-[#475467] text-sm font-normal font-['Inter'] leading-tight pb-[30px]">
          {message}
        </div>
      </div>
    </div>

  );
};

export default SuccessComponent;